type Handler = () => void;

let handler: Handler | null = null;

export function setOnUnauthorized(fn: Handler | null): void {
  handler = fn;
}

export function triggerUnauthorized(): void {
  handler?.();
}
